import { media, style } from "typestyle";
import { unit } from "../../styles";
import colors from "../../styles/colors";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";

export const top = style({
  backgroundColor: "white",
  borderBottom: `1px solid ${colors.grey[200]}`,
});

export const coverAndInfo = style(
  {
    display: "flex",
    flexDirection: "column-reverse",
    maxWidth: 800,
  },
  media(upFrom(mediaQueries.desktopSmall), {
    margin: `0 auto`,
    maxWidth: 800,
    flexDirection: "row",
  }),
  media(upFrom(mediaQueries.desktopLarge), {
    margin: `0 auto`,
    maxWidth: 1000,
    flexDirection: "row",
  }),
);

export const info = style(
  {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    $debugName: "info",
    width: "100%",
    padding: `${unit(4)} ${unit(6)} ${unit(4)}`,
  },
  media(upFrom(mediaQueries.desktopSmall), {
    padding: `${unit(6)} ${unit(8)} ${unit(8)} ${unit(0)}`,
    maxWidth: "400px",
  }),
  media(upFrom(mediaQueries.desktopLarge), {
    maxWidth: "600px",
  }),
);

export const links = style({
  display: "flex",
});

export const linkIcon = style({
  marginRight: unit(3),
  display: "inline-block",
});

export const cover = style(
  {
    display: "flex",
    flex: 1,
    marginTop: "24px",
  },
  media(upFrom(mediaQueries.desktopLarge), {
    flex: "none",
  }),
);

export const image = style(
  {},
  media(upFrom(mediaQueries.tablet), {
    overflow: "hidden",
  }),
);

export const container = style({
  margin: `${unit(12)} 0 ${unit(20)}`,
});

export const inputWrapper = style(
  {
    border: "none",
    margin: `0 ${unit(6.5)}`,
    position: "relative",
  },
  media(upFrom(mediaQueries.desktopSmall), {
    maxWidth: 600,
    margin: "0 auto",
  }),
);

export const inputIcon = style({
  position: "absolute",
  top: 20,
  left: 18,
});

export const crossIcon = style({
  position: "absolute",
  top: 22,
  right: 18,
  color: "rgba(0,0,0,0.4)",
  $nest: {
    "&:hover": {
      color: "rgba(0,0,0,0.6)",
    },
  },
});

export const input = style({
  width: "100%",
  height: 60,
  paddingLeft: 48,
  paddingRight: 18,
  outline: "none",
  border: "1px solid rgba(0,0,0,0.1)",
  borderRadius: 10,
});

export const list = style(
  {
    margin: `${unit(6)} ${unit(6.5)} 0`,
  },
  media(upFrom(mediaQueries.desktopSmall), {
    maxWidth: 600,
    margin: `${unit(6)} auto`,
  }),
);

export const listHeading = style({
  marginBottom: unit(3),
});

export const listItem = style({
  marginBottom: unit(4),
});

export const noEventsContainer = style(
  {
    margin: `${unit(10)} ${unit(5)} ${unit(10)}`,
  },
  media(upFrom(mediaQueries.desktopSmall), {
    maxWidth: 600,
    margin: `${unit(10)} auto`,
  }),
);
